module.exports = __webpack_public_path__ + "img/banner_stdn.6061829b.jpg";